import { render } from "./AuditLogsListing.vue?vue&type=template&id=b8a82a3e&scoped=true&ts=true"
import script from "./AuditLogsListing.vue?vue&type=script&lang=ts"
export * from "./AuditLogsListing.vue?vue&type=script&lang=ts"

import "./AuditLogsListing.vue?vue&type=style&index=0&id=b8a82a3e&lang=css"
import "./AuditLogsListing.vue?vue&type=style&index=1&id=b8a82a3e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a82a3e"]])

export default __exports__